<script lang="ts">
	import EndActions from '$lib/components/end-actions.svelte';
	import Image from '$lib/components/image.svelte';
	import type { Article } from '$lib/graphql/strapiApi';
	import { replaceImg } from '$lib/utils.js';
	import dayjs from 'dayjs';

	let { article }: { article: Article } = $props();
	let blocks = $derived(article.blocks ?? []);
</script>

<div class="mb-8 flex w-full justify-center">
	<div class="flex w-full max-w-screen-sm flex-col justify-center gap-y-4 px-8 pt-6">
		<p class="flex gap-x-2 whitespace-nowrap">
			{dayjs(article.published).format('MMMM D, YYYY')}
			<span>•</span>
			<span>{article.readingMinutes} min</span>
		</p>
		<h1 class="text-4xl font-bold">{article.title}</h1>
		<div class="my-4 flex flex-row items-center gap-x-4">
			{#if article.authorsBio?.avatar}<img
					class="w-12 rounded-full"
					src={article.authorsBio.avatar?.formats?.small?.url ?? article.authorsBio.avatar?.url}
					alt={article.authorsBio.name}
				/>{/if}
			<div>
				<p class="font-semibold">{article.authorsBio?.name}</p>
				<p class="text-sm">{article.authorsBio?.title}</p>
			</div>
		</div>
		{#if article.cover}<Image
				class="mb-4 rounded-xl drop-shadow-lg"
				src={article.cover?.formats?.large?.url ?? article.cover?.url}
				alt={article.title}
			/>{/if}
		{#each blocks as block}
			{#if block?.__typename === 'ComponentSharedRichText'}
				<div class="prose">{@html replaceImg(block.body, 'xlarge')}</div>
			{/if}
		{/each}
		<EndActions />
	</div>
</div>
